import { parseISO } from 'date-fns';

export const parseDate = (date: Date | string): Date => {
  return typeof date === 'string' ? new Date(parseISO(date)) : date;
};
